import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/logo/hjex-logo.svg'


const _hoisted_1 = { class: "w-screen h-screen background-blue-grey-lighten-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex justify-center pt-5" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "container-loader" }, [
  /*#__PURE__*/_createVNode("div", { class: "wrapper-loader" }, [
    /*#__PURE__*/_createVNode("div", { class: "circle" }),
    /*#__PURE__*/_createVNode("div", { class: "circle" }),
    /*#__PURE__*/_createVNode("div", { class: "circle" }),
    /*#__PURE__*/_createVNode("div", { class: "shadow" }),
    /*#__PURE__*/_createVNode("div", { class: "shadow" }),
    /*#__PURE__*/_createVNode("div", { class: "shadow" })
  ]),
  /*#__PURE__*/_createVNode("div", {
    class: "relative",
    style: {"left":"-50%","top":"-40px"}
  }, [
    /*#__PURE__*/_createVNode("p", { class: "text-center" }, [
      /*#__PURE__*/_createTextVNode("Tunggu Sebentar, kami sedang mempersiapkan "),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("segalanya untuk membuat mu nyaman..")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}